<template>
  <div class="about">
    <h1>Dec 2021,Tutorial projects Real World Vue from VueMastery</h1>
  </div>
</template>
